import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class DescontosService {
  constructor(private httpClient: HttpClient) {}

  public descontos: number = 0;
  public service: string = '/descontos';

  listar(): Promise<any> {
    return this.httpClient
      .get(this.service + '/index/' + environment.filialId)
      .toPromise();
  }
}
